import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum PaymentStatus {
  SUCCESS = 0,
  FAILED = 1,
  REFUND = 2,
}
export interface IPlanHistory {
  id: string;
  user_id: string;
  status: number;
  start_date: string;
  end_date: string;
  payment_provider: string;
  total_paid: number;
  bonus_used: number;
  payment_status: number;
  payment_description: string;
  payment_token: string;
  created_at: string;
  updated_at: string;
  plan_id: string;
  plan_name: string;
  currency_symbol: string;
}

interface IPlanHistoryState {
  history: IPlanHistory[];
}

const initialState: IPlanHistoryState = {
  history: [],
};

export const planHistorySlice = createSlice({
  name: 'planHistory',
  initialState,
  reducers: {
    setPlansHistory: (state, action: PayloadAction<IPlanHistory[] | []>) => {
      state.history = action.payload;
    },
  },
});

export const { setPlansHistory } = planHistorySlice.actions;
export default planHistorySlice.reducer;
